import React, { useEffect, useState } from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { generateProjectQuestionnaire } from '@rd-web-markets/be/dist/services/docx_generators/project_questionnair_patcher.service';
import { Row, Col, Form } from 'react-bootstrap';

const OngoingExportProjectsModal = ({title, onHide, show, reports, documentType, claimGroup}) => {
  const { t } = useTranslation();
	const [selectedProjects, setSelectedProjects] = useState([]);
	const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);

	useEffect(() => {
		setSelectedProjects(reports.filter(report => report.it_type === documentType && report.project_type === 'ongoing_project').map(p => {
			return { 
				project_name: p.project_name,
				selected: true,
				claim_group: claimGroup,
			}
		}));
  }, [documentType]);

	const generateOngoingProjectQuestionnaires = async () => {
    const leadConsultant = claimGroup.consultant_roles.find(role => role.role === 'claim_group_access_lead_consultant');
    const companyName = claimGroup.company.abbreviated_name;

    selectedProjects.filter(p => p.selected == true).forEach(async (report) => {
      await generateProjectQuestionnaire(
        {
          ...report,
          claimGroupYear: claimGroup.from_date.split('/').reverse()[0],
          companyName,
          leadConsultant: leadConsultant.user ? leadConsultant.user.name : ''
        },
        documentType === 'not_it' ? 'ongoing_non_it_project_document' : 'ongoing_it_project_document');
    });
		onHide();
  }

	const handleChange = (e, p, index) => {
		const updatedProjects = selectedProjects;
		updatedProjects[index]['selected'] = e.target.checked;
		setSaveBtnDisabled(updatedProjects.filter(up => up.selected == true).length == 0)
		setSelectedProjects([...updatedProjects]);
	}

  const modalBody = () => {
    return (
			selectedProjects.map((p, index) =>
				<Row>
					<Col md={3}>
						{p.project_name}
					</Col>
					<Col md={{span: 2, offset: 1}}>
						<Form.Check
							type="checkbox"
							name="selected"
							checked={p.selected}
							value={p.selected}
							onChange={e => handleChange(e, p, index)}
						/>
					</Col>
				</Row>
			)
    )
  }

  return (<>
    <Modal
      size="xl"
      show={show}
      title={title}
      renderBody={modalBody}
      onHide={onHide}
      disabled={saveBtnDisabled}
      onSubmit={async () => {
				generateOngoingProjectQuestionnaires();
      }}
    />
  </>)
}

export default OngoingExportProjectsModal
